import { IconButton } from "@mui/material";
import { DeleteOutline as ClearIcon } from "@mui/icons-material";
import _ from "lodash";
import useIsRecurring from "./hooks/useIsRecurring";

const ClearRecurringButton = props => {
  const isRecurring = useIsRecurring(props.form);
  if (!isRecurring) return null;
  
  return <IconButton onClick={() => props.form.resetField("recurring")} style={{ alignSelf: "start" }}>
    <ClearIcon fontSize="small" color="primary" />
  </IconButton>;
};

export default ClearRecurringButton;